import { fetchNetworkExplorerStats, type NetworkExplorerStats } from '@/api/networkExplorerApi';
import type { StatsPeriod } from '@/api/statsApi';
import { useCachedStats } from './useCachedStats';

/** Exported for test isolation only — do not call in production code. */
export function _clearNetworkExplorerStatsCache() {
    cache.clear();
}

// One estate, one figure set per period: a module-level cache kept across remounts within the
// browser session (like the single-client stats cache) so leaving and re-entering the explorer,
// or switching the period back, does not flash a loading skeleton.
const cache = new Map<string, NetworkExplorerStats>();

/**
 * The estate-wide statistics for the Network Explorer header over the chosen period. Takes
 * no client and no filters — the row set is the server's to decide from the caller's
 * permission.
 */
export function useNetworkExplorerStats(period: StatsPeriod): {
    data: NetworkExplorerStats | null;
    isLoading: boolean;
    isError: boolean;
} {
    return useCachedStats({ key: period, fetch: (signal) => fetchNetworkExplorerStats(period, signal) }, cache);
}
